import { Icon } from '@iconify/react'
import type { FC } from 'react'

import styles from './ehrAppointmentV2.module.scss'

export const PREVIEW_PLACEHOLDER_TITLE = 'Pick an open slot'
export const PREVIEW_PLACEHOLDER_TEXT =
  "Its day opens here, with the doctor's bookings and this visit in place."

// A faint sketch of the day grid; decoration only.
const GHOST_HOURS = ['9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM']

// Stands in for the day preview until a slot is picked, so no stale or wrong day is drawn.
export const PreviewPlaceholder: FC = () => (
  <div className={styles.preview}>
    <div className={styles.previewHeader}>
      <span>Day preview</span>
    </div>
    <div className={`${styles.previewBody} ${styles.placeholderBody}`}>
      <div className={styles.placeholderGrid} aria-hidden>
        {GHOST_HOURS.map((hour) => (
          <div key={hour} className={styles.placeholderRow}>
            <span className={styles.placeholderHour}>{hour}</span>
          </div>
        ))}
        <div className={styles.placeholderSlot} />
      </div>

      <div className={styles.placeholderCard} role='status'>
        <span className={styles.placeholderIcon}>
          <Icon icon='ph:calendar-plus' fontSize={22} />
        </span>
        <span className={styles.placeholderTitle}>{PREVIEW_PLACEHOLDER_TITLE}</span>
        <span className={styles.placeholderText}>{PREVIEW_PLACEHOLDER_TEXT}</span>
      </div>
    </div>
  </div>
)
